import client from './client';

export async function fetchUserProfile() {
  const res = await client.get('/users/me');
  return res.data;
}

export async function submitUserProfile(data) {
  const res = await client.post('/users/me', data);
  return { status: res.status, data: res.data };
}

export function getCachedProfile() {
  try {
    return JSON.parse(localStorage.getItem('userProfile') || 'null');
  } catch {
    return null;
  }
}

export function cacheProfile(profile) {
  localStorage.setItem('userProfile', JSON.stringify(profile));
}

export function clearCachedProfile() {
  localStorage.removeItem('userProfile');
}

export async function updateLanguagePreference(lang) {
  return client.patch('/users/me/language', { language: lang });
}
